import component from './loadable';

export default component;
